import React, { useState, useEffect, useMemo } from 'react';
import {
  getTransacWeek, getTransacMonth, getTransacSouscat,
  getUser, getYears,
  getCiteRev
} from '../API';
import dayjs from 'dayjs'
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Brush } from 'recharts';
import TreemapComponent from '../components/TreemapRecharts.js'
import { useTable, usePagination, useSortBy, useFilters } from 'react-table'

const chartDateAxisProps = {
  angle: -90,
  textAnchor: 'end',
  height: 72,
  tick: { fill: '#1f2937', fontSize: 10 },
  axisLine: { stroke: '#5b6478' },
  tickLine: { stroke: '#5b6478' },
};

const chartValueAxisProps = {
  tick: { fill: '#1f2937' },
  axisLine: { stroke: '#5b6478' },
  tickLine: { stroke: '#5b6478' },
};

const chartBrushProps = {
  height: 36,
  stroke: '#5b6478',
  fill: '#eef2ff',
  travellerWidth: 10,
  tickFormatter: () => '',
};

const chartTooltipProps = {
  cursor: { fill: 'rgba(59, 108, 244, 0.08)' },
  contentStyle: {
    background: '#ffffff',
    border: '1px solid #e3e8f2',
    borderRadius: 12,
    boxShadow: '0 8px 24px rgba(10, 17, 114, 0.12)',
    color: '#1f2937',
  },
  labelStyle: { color: '#5b6478', fontWeight: 600 },
  itemStyle: { color: '#1f2937' },
};

const YearPills = ({ years, yearSelect, onChange }) => (
  <div className="dashboard-year-pills" role="group" aria-label="Année">
    {years.map((entry) => (
      <button
        key={entry.year}
        type="button"
        className={`dashboard-year-pill${String(yearSelect) === String(entry.year) ? ' dashboard-year-pill-active' : ''}`}
        value={entry.year}
        onClick={onChange}
      >
        {entry.year}
      </button>
    ))}
  </div>
);

function Table({ columns, data }) {

  const [selectedRow, setSelectedRow] = useState(-1);

  // const [filterInput, setFilterInput] = useState("");

  // const handleFilterChange = e => {
  //   const value = e.target.value || undefined;
  //   setFilter("route_id", value); // Update this specific field
  //   setFilterInput(value);
  // };

  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page, // Instead of using 'rows', we'll use page,
    // which has only the rows for the active pagconst [cellValue, setCellValue] = useState('');e

    // The rest of these things are super handy, too ;)
    // canPreviousPage,
    // canNextPage,
    // pageOptions,
    // pageCount,
    // gotoPage,
    // nextPage,
    // previousPage,
    // setPageSize,
    // setFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0 },

      sortTypes: {
        custom: (rowA, rowB, columnId) => {
          const a = rowA.values[columnId];
          const b = rowB.values[columnId];

          if (!isNaN(Number(a)) && !isNaN(Number(b))) {
            return Number(a) - Number(b);
          }
          return a.localeCompare(b);
        }
      },
    },
    useFilters,
    useSortBy,
    usePagination,
  )

  const handleRowHover = (e) => {
    setSelectedRow(e.id);
  }

  const handleMouseOut = () => {
    setSelectedRow(-1);
  }

  // const handleCellClick = (e) => {

  // }

  // Render the UI for your table
  return (

    <>
      {/* {headerGroups[0].headers.find((e) => { return e.id === 'code' }) ? <div className="row">
        <div className="col-12 text-center">
          <input
            value={filterInput}
            onChange={handleFilterChange}
            placeholder={'Trouver un code...'}
          />
        </div>
      </div > : ''} */}
      <div className="dashboard-table-wrap">
        <table className="table dashboard-table" {...getTableProps()}>
          <thead>
            {headerGroups.map(headerGroup => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                    {column.render('Header')}
                    <span>
                      {column.isSorted
                        ? column.isSortedDesc
                          ? ' ↓'
                          : ' ↑'
                        : ''}
                    </span>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row) => {
              prepareRow(row);

              return (
                <tr
                  className={row.id === selectedRow ? 'dashboard-table-row-active' : ''}
                  onMouseMove={() => handleRowHover(row)}
                  onMouseOut={handleMouseOut}
                  {...row.getRowProps()}
                >
                  {row.cells.map(cell => (
                    <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                  ))}
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>

    </>
  )
}



const Dashboard = () => {

  const columns = useMemo(
    () => [
      {
        Header: 'Code',
        accessor: 'code',
      },
      {
        Header: 'Cité de la santé',
        accessor: 'cite',
      },
      {
        Header: 'Consultations',
        accessor: 'consult',
      },
      {
        Header: 'Révisions tumeurs',
        accessor: 'revision',
      },
      {
        Header: 'Total',
        accessor: 'total',
      }
    ],
    []
  )




  const [cases, setCases] = useState('');

  const [user, setUser] = useState('');
  const [userid, setUserid] = useState('');
  const [years, setYears] = useState();
  const [yearSelect, setYearSelect] = useState(dayjs().year());
  const [weekly, setWeekly] = useState('');
  const [monthly, setMonthly] = useState('');
  const [sousCat, setSousCat] = useState('');
  const [refreshKey, setRefreshKey] = useState(0);


  useEffect(() => {
    getUser().then(usr => {
      setUser(usr);
      setUserid(usr.profileid)
      getYears().then(yrs => {
        setYears(yrs)
        setYearSelect(yrs[0].year)
        getCiteRev(yrs[0].year).then(cas => {
          setCases(cas);
        })
      })
      getTransacWeek().then(trwk => {
        trwk.forEach((t) => {
          t.weekFormat = t.week.substr(0, 10);
        })
        setWeekly(trwk);
      })
      getTransacMonth().then(trmth => {
        trmth.forEach((t) => {
          t.monthFormat = t.month.substr(0, 7);
        })
        setMonthly(trmth);
      })

    })
  }, [])


  useEffect(() => {
    if (user !== '') {
      getTransacSouscat(yearSelect).then(trsc => {
        setSousCat(trsc[0].jsonb_build_object.data)
      })
      getCiteRev(yearSelect).then(cas => {
        setCases(cas);
      })
    } else {
      getUser().then(usr => {
        getYears().then(yrs => {
          getTransacSouscat(yrs[0].year).then(trsc => {
            setSousCat(trsc[0].jsonb_build_object.data)
          })
          getCiteRev(yearSelect).then(cas => {
            setCases(cas);
          })
        })
      })
    }
  }, [refreshKey])


  const handleChangeYear = (yearSelect) => {
    setYearSelect(yearSelect.target.value);
    setRefreshKey(oldKey => oldKey + 1);
  }

  return weekly !== '' && monthly !== '' && years.length > 0
    && user !== '' && userid !== '' && cases ? (
    <div className="container dashboard-page">
      <header className="dashboard-page-header">
        <p className="page-eyebrow">Statistiques</p>
        <h1>Tableau de bord</h1>
        <p className="page-lead">Visualisez vos points par semaine, par mois et par code.</p>
      </header>

      {cases.length > 0 && (userid === process.env.REACT_APP_usertable || userid === process.env.REACT_APP_usertable1) ? (
        <section className="chart-card dashboard-hemato-card">
          <div className="dashboard-chart-header">
            <div>
              <h2>Hémato {yearSelect}</h2>
              <p>Répartition des cas par code et par type</p>
            </div>
            <span className="dashboard-chart-icon" aria-hidden="true">
              <i className="fas fa-notes-medical"></i>
            </span>
          </div>
          <Table columns={columns} data={cases} />
          <YearPills years={years} yearSelect={yearSelect} onChange={handleChangeYear} />
        </section>
      ) : null}

      <section className="chart-card">
        <div className="dashboard-chart-header">
          <div>
            <h2>Points par semaine</h2>
            <p>Évolution hebdomadaire des points enregistrés</p>
          </div>
          <span className="dashboard-chart-icon dashboard-chart-icon-week" aria-hidden="true">
            <i className="fas fa-chart-bar"></i>
          </span>
        </div>
        <ResponsiveContainer width="100%" height={420}>
          <BarChart data={weekly} margin={{ top: 8, right: 8, bottom: 8, left: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e3e8f2" vertical={false} />
            <XAxis
              dataKey="weekFormat"
              {...chartDateAxisProps}
            />
            <YAxis
              {...chartValueAxisProps}
            />
            <Tooltip {...chartTooltipProps} />
            <Bar dataKey="points" fill="#3b6cf4" radius={[6, 6, 0, 0]} maxBarSize={42} />
            <Brush
              dataKey="weekFormat"
              {...chartBrushProps}
            />
          </BarChart>
        </ResponsiveContainer>
      </section>

      <section className="chart-card">
        <div className="dashboard-chart-header">
          <div>
            <h2>Points par mois</h2>
            <p>Volume mensuel de points enregistrés</p>
          </div>
          <span className="dashboard-chart-icon dashboard-chart-icon-month" aria-hidden="true">
            <i className="fas fa-chart-area"></i>
          </span>
        </div>
        <ResponsiveContainer width="100%" height={420}>
          <BarChart data={monthly} margin={{ top: 8, right: 8, bottom: 8, left: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e3e8f2" vertical={false} />
            <XAxis
              dataKey="monthFormat"
              {...chartDateAxisProps}
            />
            <YAxis
              {...chartValueAxisProps}
            />
            <Tooltip {...chartTooltipProps} />
            <Bar dataKey="points" fill="#0d9488" radius={[6, 6, 0, 0]} maxBarSize={42} />
            <Brush
              dataKey="monthFormat"
              {...chartBrushProps}
            />
          </BarChart>
        </ResponsiveContainer>
      </section>

      <section className="chart-card">
        <div className="dashboard-chart-header dashboard-chart-header-split">
          <div>
            <h2>Points par code</h2>
            <p>Répartition des points par code pour {yearSelect}</p>
          </div>
          <span className="dashboard-chart-icon dashboard-chart-icon-code" aria-hidden="true">
            <i className="fas fa-th-large"></i>
          </span>
        </div>
        <YearPills years={years} yearSelect={yearSelect} onChange={handleChangeYear} />
        <ResponsiveContainer width="100%" height={500}>
          <TreemapComponent
            treeData={sousCat}
          />
        </ResponsiveContainer>
      </section>
    </div>
  ) : (
    <div className="container dashboard-page">
      <div className="chart-card dashboard-loading-card">
        <span className="dashboard-loading-spinner" aria-hidden="true"></span>
        <p className="dashboard-loading">Chargement du tableau de bord...</p>
      </div>
    </div>
  );
}


export default Dashboard;